import { Base2Presenter } from "core/presenter";
import { CompanyRepository } from "core/repository";
import { CustomerFields } from "core/enum";
import _ from "lodash";
import * as R from "ramda";

class ManageFieldsPresenter extends Base2Presenter {
  initialState() {
    return {
      loading: false,
      visible: false,
      fields: CustomerFields,
      customFields: []
    };
  }

  async onStart() {
    this.enqueue({ loading: true });

    const currentUser = await this.mRuntime.get("currentUser");
    const result = await CompanyRepository.get(currentUser.company_uuid, true);

    const configuration = [...result.data.customer_fields, ...CustomerFields];
    const fields = _.uniqBy(configuration, "key");

    if (result.success) {
      this.enqueue({
        customFields: result.data.customer_custom_fields,
        fields
      });
    } else {
      this.sendNotification({
        type: "error",
        title: "Oops",
        content:
          "Não foi possível obter os dados da empresa.\nTente novamente mais tarde ou entre em contato com o suporte."
      });
    }

    this.enqueue({ loading: false });
  }

  onOpenModal() {
    this.enqueue({ visible: true });
  }

  onCloseModal(updatedFields) {
    this.enqueue({ visible: false, customFields: updatedFields });
  }

  handleChangeCheckBox(field, index, value) {
    if (field === "show" && !value) {
      const fields = this.viewModel.fields;
      fields[index][field] = value;
      fields[index]["required"] = false;

      return this.enqueue({ fields });
    }

    const fields = this.viewModel.fields;
    fields[index][field] = value;

    this.enqueue({ fields });
  }

  async onSendForm() {
    this.enqueue({ loading: true });

    const fields = this.viewModel.fields.filter(
      field => field.show === false || field.required === true
    );
    const validFields = this.validFields(fields);

    if (!validFields) {
      this.enqueue({ loading: false });

      this.sendNotification({
        type: "error",
        title: "Oops",
        content:
          'É necessário que pelo menos um dos campos entre: "Nome", "Identificação" e "E-mail", sejam exibidos no cadastro.'
      });

      return;
    }

    const currentUser = await this.mRuntime.get("currentUser");
    const update = await CompanyRepository.update(currentUser.company_uuid, {
      customer_fields: fields
    });

    if (update.success) {
      this.sendNotification({
        type: "success",
        content: "Alterações salvas com sucesso!"
      });

      this.onGoBack();
    } else {
      this.sendNotification({
        type: "error",
        title: "Oops",
        content:
          "Não foi possível salvar as alterações.\nTente novamente mais tarde ou entre em contato com o suporte."
      });
    }

    this.enqueue({ loading: false });
  }

  onGoBack() {
    this.navigateTo("app.registration.customer");
  }

  validFields(fields) {
    const compare = [
      {
        field: "Nome",
        required: false,
        show: false,
        key: "name",
        tab: "general"
      },
      {
        field: "E-mail",
        required: false,
        show: false,
        key: "email",
        tab: "general"
      },
      {
        field: "Identificação",
        required: false,
        show: false,
        key: "identification",
        tab: "general"
      }
    ];

    if (fields.length > 0) {
      const result = R.difference(compare, fields);

      if (result.length === 0) {
        return false;
      }

      return true;
    }

    return true;
  }
}

export default ManageFieldsPresenter;



// WEBPACK FOOTER //
// ./src/components/app/registration/customer/manage-fields/presenter.js